import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { withDefault } from '@vy/utils';
import React from 'react';

type MonthOption = {
  value: string;
  label: string;
};

type CustomerPortalMonthSelectorProps = {
  availableMonths: MonthOption[];
  selectedMonth: string | null;
  onMonthChange: (month: string | null) => void;
};

export const CustomerPortalMonthSelector: React.FC<CustomerPortalMonthSelectorProps> = ({
  availableMonths,
  selectedMonth,
  onMonthChange,
}) => {
  return (
    <Box sx={{ width: '134px' }}>
      <Typography
        sx={{
          fontSize: '10px',
          fontFamily: 'Inter, sans-serif',
          color: 'rgba(27, 61, 85, 0.6)',
          marginBottom: '4px',
        }}
      >
        Show by
      </Typography>
      <FormControl fullWidth size="small">
        <Select
          value={withDefault(selectedMonth, '')}
          onChange={(e) => onMonthChange(e.target.value ?? null)}
          sx={{
            width: '134px',
          }}
        >
          {availableMonths.map((month) => (
            <MenuItem key={month.value} value={month.value}>
              {month.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
